export default "__VITE_ASSET__99736b6e__"